<template>
  <div class="page-tabs">
    <tabs
      v-bind="$attrs"
      v-on="$listeners"
      :items="visibleTabs"
      @change="setTab"
    />
  </div>
</template>

<script>
import tabs from "@/qux-common/qux22/components/molecules/tabs";
import { mapGetters } from "vuex";
import tabData from "./tabData";
import isVisible from "@/util/isVisibleElement";

export default {
  components: {
    tabs,
  },
  methods: {
    setTab(tab) {
      this.$emit(
        "setTab",
        this.visibleTabs.find((currTab) => currTab.href == "#" + tab)["name"]
      );
    },
  },
  computed: {
    visibleTabs() {
      if (!this.activeTab || !this.activeTab.subTabValid) return [];
      const visibleTabs = tabData.filter(
        (tab) =>
          !(
            !this.configTemplate[tab.category] ||
            !isVisible(
              this.accessRoles,
              this.config[this.activeTab.ClientInfoRuleId],
              this.configTemplate[tab.category]
            )
          )
      );

      const invalidTabs = Object.entries(this.activeTab.subTabValid)
        .filter(([, value]) => !value)
        .map(([key]) => key);

      return visibleTabs.map((tab) => {
        const isTabValid = invalidTabs.includes(tab.id);
        return {
          name: tab.name,
          href: tab.href,
          leftIcon: isTabValid && "mdi-alert-outline",
          leftIconTooltip: isTabValid && "There are invalid values",
        };
      });
    },
    ...mapGetters({
      config: "getConfig",
      configTemplate: "getConfigTemplate",
      activeTab: "getActiveTab",
      accessRoles: "getRoles",
    }),
  },
  data() {
    return {
      tabData,
    };
  },
};
</script>

<style lang="scss" scoped>
.page-tabs {
  &::v-deep {
    .v-tab {
      text-transform: none;
    }
  }
}
</style>